import { z } from "zod";

//? DTO
export const AccommodationReservationClientDtoSchema = z.object({
  AccommodationId: z.number(),
  ReservationId: z.number(),
  ClientId: z.number(),
});

export type AccommodationReservationClientDto = z.infer<
  typeof AccommodationReservationClientDtoSchema
>;

//? Model

export const AccommodationReservationClientSchema = z.object({
  accommodationId: z.number(),
  reservationId: z.number(),
  clientId: z.number(),
});

export type AccommodationReservationClient = z.infer<
  typeof AccommodationReservationClientSchema
>;

//? Mapper
export function AccommodationReservationClientFromDto(
  dto: AccommodationReservationClientDto
): AccommodationReservationClient {
  return {
    accommodationId: dto.AccommodationId,
    reservationId: dto.ReservationId,
    clientId: dto.ClientId,
  };
}
export function AccommodationReservationClientToDto(
  model: AccommodationReservationClient
): AccommodationReservationClientDto {
  return {
    AccommodationId: model.accommodationId,
    ClientId: model.clientId,
    ReservationId: model.reservationId,
  };
}
